'use client';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { sleep } from '../../../utils/sleep';
import { isBrowser } from '../../../utils/isBrowser';

export default function AdsChecker() {
  const pathname = usePathname();
  const handleRouteChange = async () => {
    await sleep(500);
    const insEls = Array.from(document.querySelectorAll('ins.adsbygoogle') || []);
    const insWithNoAds = insEls.filter(i => !i.childNodes.length);
    // @ts-ignore
    for (const ins of insWithNoAds) (adsbygoogle = window.adsbygoogle || []).push({});

  }
  useEffect(() => {
    if (!isBrowser()) return;
     handleRouteChange();
  }, [pathname]);
  return null;
}